export const IMPORT_PANEL_QS = `importPanel`;

export enum REPORT_PANEL_GRID_MENU {
  IMPORT_PANEL,
  ADD_PANEL,
}
